let cc_title = document.querySelectorAll('.cc_title p');
if (cc_title) {
    anime({
        targets: cc_title,
        translateY: [200, 0],
        opacity: [0, 1],
        delay: anime.stagger(300),
        duration: 1000
        
    });
}


let blogTitle = document.querySelectorAll('.title--primary span'),
news = document.querySelector('.news')

if (blogTitle) {
    anime({
        targets: blogTitle[0],
        scale: [0, 1],
        duration: 1500
    });
}


if (news) {
    let newsLetters = news.innerText.split('');
    news.innerHTML = '';
    newsLetters.forEach(letter => {
        let span = document.createElement('span');
        span.innerText = letter;
        news.appendChild(span);
    });

    anime({
        targets: document.querySelectorAll('.news span'),
        translateY: [200, 0],
        opacity: [0, 1],
        delay: anime.stagger(200, {start: 1000}),
        duration: 1000
    })
}
